module.exports = __webpack_public_path__ + "img/GRI-logo.80b613ef.png";